function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { ref } from "vue";
import { RatioType } from "video-editor-renderer";
import { addSegmentFragmentFromTemplate } from "@ve-pro/store/tracks/add-segment-fragment";
import { useTrackStore, useHistoryStore, useProjectStore, useSegmentHistoryStore } from "@ve-pro/store";
import { fillSegmentsRatio } from "@ve-pro/store/tracks/segment/segment-ratio";
import { useSave } from "@ve-pro/ve/hotkeys/shortcuts/save/save-action";
import { localLanguage } from "@/common/storage";
import _ from "lodash";
// 当前tab
export var tabValue = ref();
// 列表loading
export var listLoading = ref(false);
// 模版详情loading
export var detailLoading = ref(false);
// 添加的模版
export var templateAsset = ref();
// 替换项目弹窗
export var dialogVisible = ref(false);
// 比例不一致弹窗
export var ratioVisible = ref(false);
// 缺失的比例
export var missRatioList = ref([]);
// 根据比例计算封面图的宽度
export function getImgWidth(ratio) {
    var base = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
    var _$ref = _slicedToArray(ratio.toString().split(":"), 2), width = _$ref[0], height = _$ref[1];
    var w = Number(width);
    var h = Number(height);
    return Math.floor(w * (base / h));
}
// 根据比例计算封面图的高度
export function getImgHeight(ratio) {
    var base = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 136;
    var _$ref = _slicedToArray(ratio.toString().split(":"), 2), width = _$ref[0], height = _$ref[1];
    var w = Number(width);
    var h = Number(height);
    return Math.floor(h * (base / w));
}
// 模版列表解析，根据项目语言展示对应的封面和视频
export function defaultTemplateList(list) {
    return list.map(function(x) {
        // 模版名称
        var nameMaps = {
            "zh-cn": x.name,
            en: x.name_en || x.name,
            ja: x.name_jp || x.name_en || x.name
        };
        return _objectSpreadProps(_objectSpread({}, x), {
            name: nameMaps[localLanguage.get()],
            cover_previews: getUrl(x.cover_previews),
            previews: getUrl(x.previews)
        });
    });
}
function getUrl(url) {
    // 平台语言-项目语言,没有项目语言默认原语言
    var langMaps = {
        "zh-cn": "zh-CN",
        en: "",
        ja: "ja-JP"
    };
    if (url) {
        if (!_.isUndefined(JSON.parse(url)[langMaps[localLanguage.get()]])) {
            return filterEmptyObjects(JSON.parse(url)[langMaps[localLanguage.get()]]);
        }
        return filterEmptyObjects(JSON.parse(url)[""]);
    }
    return "";
}
// 过滤空对象(兼容模版item历史数据)
export function filterEmptyObjects(obj) {
    var filteredObj = {};
    for(var key in obj){
        if (typeof obj[key] === "object" && obj[key] !== null) {
            var filteredValue = filterEmptyObjects(obj[key]);
            if (Object.keys(filteredValue).length > 0) {
                filteredObj[key] = filteredValue;
            }
        } else if (obj[key] !== undefined && obj[key] !== "" && obj[key] !== null) {
            filteredObj[key] = obj[key];
        }
    }
    return filteredObj;
}
// 获取ratio的icon
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getRatioIcon(ratio) {
    switch(ratio){
        case RatioType["9:16"]:
            return Ic916;
        case RatioType["3:4"]:
            return Ic34;
        case RatioType["4:5"]:
            return Ic45;
        case RatioType["1:1"]:
            return Ic11;
        case RatioType["16:9"]:
            return Ic169;
        case RatioType["4:3"]:
            return Ic43;
        case RatioType["2:1"]:
            return Ic21;
        default:
            return null;
    }
}
// 片段尺寸的优先展示顺序
export function defaultRatio(ratios) {
    if (ratios.includes(RatioType["9:16"])) {
        return RatioType["9:16"];
    } else if (ratios.includes(RatioType["16:9"])) {
        return RatioType["16:9"];
    }
    return ratios[0];
}
// 视频模版标签label
export function getTemplateTags(templateTags, tageIds) {
    if (templateTags.length && tageIds) {
        var template_tags = templateTags.filter(function(item) {
            return item.child !== null;
        }).map(function(item) {
            return item.child;
        }).flat();
        var tage_ids = tageIds && tageIds.split(",").map(Number);
        return template_tags.filter(function(t) {
            return tage_ids.includes(t.id);
        });
    }
    return [];
}
// 检查项目中缺少的比例
export function checkMissRatio(RatioMap) {
    var projectStore = useProjectStore();
    return RatioMap.filter(function(key) {
        return !projectStore.ratios.includes(key);
    });
}
// 模版添加到轨道
export var handleAddAsset = function(param) {
    var loading = param.loading, asset = param.asset;
    var trackStore = useTrackStore();
    templateAsset.value = asset;
    // 缺少的比例
    var ratios;
    if (templateAsset.value && templateAsset.value.hasOwnProperty("project")) {
        var _$ref;
        ratios = (_$ref = templateAsset.value) === null || _$ref === void 0 ? void 0 : _$ref.project.ratios.split(",");
    } else {
        var _$ref1;
        ratios = (_$ref1 = templateAsset.value) === null || _$ref1 === void 0 ? void 0 : _$ref1.ratios.split(",");
    }
    // 项目内缺少的模版比例
    var missingRatios = checkMissRatio(ratios);
    missRatioList.value = missingRatios;
    // 轨道数据是否为空
    if (trackStore.tracks.length) {
        dialogVisible.value = true;
    } else {
        if (missRatioList.value.length) {
            dialogVisible.value = false;
            ratioVisible.value = true;
        } else {
            handleAdd({
                asset: asset,
                loading: loading
            });
        }
    }
};
function handleAdd(param) {
    var asset = param.asset, loading = param.loading;
    if (loading) {
        loading.value = true;
    }
    var historyStore = useHistoryStore();
    var trackStore = useTrackStore();
    var task = addSegmentFragmentFromTemplate(asset);
    task.then(function() {
        trackStore.activeSegmentFragment = null;
        historyStore.push();
        return useSave();
    }).finally(function() {
        if (loading) {
            loading.value = false;
        }
    });
    return task;
}
// 添加新比例
export function addNewRatios() {
    var projectStore = useProjectStore();
    var historyStore = useHistoryStore();
    var segmentHistoryStore = useSegmentHistoryStore();
    if (templateAsset.value) {
        // 原有比例的基础上增加缺失的比例
        var newRatios = _toConsumableArray(projectStore.ratios).concat(_toConsumableArray(missRatioList.value));
        projectStore.ratios = newRatios;
        fillSegmentsRatio();
        // 增加ratio后清空历史记录
        segmentHistoryStore.clear();
        historyStore.clear();
        return handleAdd({
            asset: templateAsset.value
        });
    }
    return Promise.resolve();
}
// 清空轨道元件并替换新的模版
export function handleReplace() {
    if (templateAsset.value) {
        return handleAdd({
            asset: templateAsset.value
        });
    }
    return Promise.resolve();
}
